import axios from "@/plugins/axios";

let url = "/api/v1/theme";

export const theme = {
    get(){
        return axios.get(`${url}`).then(result => result.data);
    },
}
